import { isArray, isBoolean, isNil, isObject } from 'lodash';
import ValueParser, {
  IValueParserOptions,
  PossibleValue,
} from './IValueParser';
import { NumberParser } from '../../utils/NumberParser';

class CurrencyValueParser implements ValueParser {
  parse = (value: PossibleValue, options?: IValueParserOptions) => {
    if (isNil(value)) {
      return '';
    }

    if (isArray(value) || isObject(value)) {
      return '';
    }

    if (isBoolean(value)) {
      return JSON.stringify(value);
    }

    const converted = NumberParser.convertStringToNumber(value, {
      format: options?.numberFormat,
    });

    if (converted === null) {
      return `${value}`;
    }

    return Number(converted);
  };
}

export default CurrencyValueParser;
